module.exports = __webpack_public_path__ + "static/media/achievement.f59c479d.png";